module.exports = __webpack_public_path__ + "static/media/football-resized.9a37290b.jpg";